module.exports = "<div id=\"hide-menu\" class=\"btn-header pull-right\">\n        <span> <a (click)=\"onToggle()\" title=\"Thu gọn menu bên trái\"><i\n                class=\"fa fa-reorder\"></i></a> </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/header/collapse-menu/collapse-menu.component.html
// module id = ./src/app/shared/layout/header/collapse-menu/collapse-menu.component.html
// module chunks = main